import { insertBody } from "../DomUtilities/ElementsUtil";
import Mediator from "../Utilities/Mediator";

export default class TablePager {
	lastPage: number;
	currentPage: number;
	pager: HTMLTableCellElement;
	pageNumberSpans: HTMLSpanElement[];
	readonly MAX_CHILDS: number = 7;
	readonly MIN_CHILDS: number = 3;

	constructor(currentPage: number, lastPage: number) {
		this.pager = document.querySelector('.table__footer');
		this.currentPage = currentPage;
		this.lastPage = lastPage;

		this.init();
	}

	private init() {
		this.pageNumberSpans = new Array(this.lastPage);
		for (let i = 0; i < this.lastPage; i++) {
			this.pageNumberSpans[i] = document.createElement('span');
			this.pageNumberSpans[i].innerText = `${i + 1}`;
			if (this.currentPage == (i + 1)) {
				this.pageNumberSpans[i].classList.add('current-page');
			}
		}
		if (this.lastPage == 1) {
			insertBody(this.pager, this.pageNumberSpans[0]);
		} else {
			this.insertNumbers();
		}
		this.addSpansClickListeners(...this.pageNumberSpans);
	}

	private insertNumbers() {
		let length = this.Length;
		const pagerElements: Array<HTMLElement> = new Array<HTMLElement>(length);
		pagerElements[0] = this.pageNumberSpans[0];
		pagerElements[1] = this.Dots;
		pagerElements[length - 2] = this.Dots;
		pagerElements[length - 1] = this.pageNumberSpans[this.lastPage - 1];
		let { start, end } = this.LoopBoundries;
		for (let i = start, index = 2; i <= end || index < length - 2; i++, index++) {
			if (i > 0 && this.pageNumberSpans[i] && index < length - 2) {
				pagerElements[index] = this.pageNumberSpans[i];
			}
		}
		insertBody(this.pager, ...pagerElements);
	}

	private get LoopBoundries(): { start: number; end: number; } {
		let start: number;
		let end: number;
		if (this.Length < 7) {
			start = 1;
			end = this.lastPage - 2;
		} else {
			switch (this.currentPage) {
				case 1:
				case 2:
					start = 1;
					end = 3;
					break;
				case this.lastPage:
				case this.lastPage - 1:
					start = this.lastPage - 4;
					end = this.lastPage - 2;
					break;
				default:
					start = this.currentPage - 2;
					end = this.currentPage;
					break;
			}
		}

		return { start, end };
	}

	private get Length(): number {
		if (this.lastPage > 5) {
			return this.MAX_CHILDS;
		}
		if (this.lastPage > 2) {
			return this.lastPage + 2;
		}
		return this.MIN_CHILDS;
	}

	private addSpansClickListeners(...spans: HTMLSpanElement[]) {
		spans.forEach(span => {
			span.onclick = () => {
				let pageNumber = parseInt(span.innerText);
				if (pageNumber != this.currentPage) {
					Mediator.emit("currentPageChanged", pageNumber);
				}
			}
		});
	}

	private get Dots(): HTMLElement {
		const DotsWrapper = document.createElement('i');
		DotsWrapper.innerText = "....";
		return DotsWrapper;
	}
}
